import styled from 'styled-components';

export const OurVisionMissionWrapper = styled.section`
  background-color: #f2f2f2;
`;
export const OurVisionMissionContainer = styled.div`
  max-width: 1170px;
  padding-top: 100px;
  padding-bottom: 100px;
  position: relative;
  margin: 0px auto;
  @media (max-width: 1200px) {
    max-width: 1100px;
    padding-left: 15px;
    padding-right: 15px;
  }
  @media (max-width: 992px) {
    max-width: 960px;
    padding-top: 50px;
    padding-bottom: 50px;
  }
  @media (max-width: 768px) {
    max-width: 720px;
  }
  @media (max-width: 576px) {
    max-width: 540px;
  }
`;
export const OurVisionMissionRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  @media (max-width: 992px) {
    flex-direction: column;
  }
`;
export const OurVisionMissionColumn = styled.div`
  max-width: 470px;
  @media (max-width: 992px) {
    max-width: 100%;
  }
`;
export const OurVisionMissionTitle = styled.h2`
  font-size: 30px;
  line-height: 30px;
  margin: 0px;
  padding-top: 34px;
  color: #000;
  text-align: center;
  @media (max-width: 1199px) {
    font-size: 26px;
    line-height: 30px;
    margin-bottom: 0px;
  }
  @media (max-width: 992px) {
    padding-top: 0px;
  }
  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 0;
  }
`;
export const OurVisionMissionDescription = styled.p`
  padding-top: 50px;
  margin: 0px;
  font-size: 14px;
  line-height: 20px;
  color: #898989;
  padding-bottom: 35px;
  @media (max-width: 1200px) {
    padding-top: 20px;
  }
  @media (max-width: 992px) {
    padding-bottom: 0px;
    padding-top: 15px;
  }
`;
export const OurVisionMissionSeperator = styled.div`
  width: 1px;
  height: auto;
  background: #b0b0b0;
  margin-left: 115px;
  margin-right: 115px;
  @media (max-width: 1300px) {
    margin-left: 60px;
    margin-right: 60px;
  }
  @media (max-width: 992px) {
    width: 100%;
    height: 1px;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 20px;
    margin-bottom: 20px;
    background-color: #b0b0b0;
  }
`;
